<template>
    <div>
        <b-form-group :label="label" class="mb-0"></b-form-group>
        <div class="d-flex">
            <b-form-group class="flex-grow-1 mb-0">
                <b-form-input
                    v-if="!isExpanded"
                    :type="type"
                    :value="value"
                    @input="$emit('input', $event)"
                    v-check-min-max-value
                    :placeholder="placeholder"
                ></b-form-input>
                <multi-text
                    v-else
                    :value="value"
                    @input="$emit('input', $event)"
                    :only-number-and-enter="onlyNumber"
                />
            </b-form-group>

            <b-button
                @click="toggle"
                class="ml-2 rounded flex-grow-0"
                variant="outline-secondary"
                style="height: 38px;"
            >
                <i :class="isExpanded ? 'ri-fullscreen-exit-line' : 'ri-fullscreen-line'"></i>
            </b-button>
        </div>
    </div>
</template>

<script>
import MultiText from "@/components/interactive-fields/MultiText.vue";

export default {
    name: 'MultiFilterInput',
    components: { MultiText },
    props: {
        value: [String, Number, Array],
        label: String,
        placeholder: String,
        type: { type: String, default: 'text' },
        onlyNumber: { type: Boolean, default: false },
        filterKey: String
    },
    data() {
        return {
            isExpanded: false
        };
    },
    methods: {
        toggle() {
            this.isExpanded = !this.isExpanded;
            if (!this.isExpanded) {
                this.$emit('input', null);
            }
        }
    }
};
</script>
